import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0,612.001 L425,612.001 L425,187 L0,187 L0,612.001 Z M640,507.001 L1920,507.001 L1920,282.001 L640,282.001 L640,507.001 Z M0,1172.001 L425,1172.001 L425,747.001 L0,747.001 L0,1172.001 Z M640,1072.001 L1920,1072.001 L1920,847.001 L640,847.001 L640,1072.001 Z M0,1732.001 L425,1732.001 L425,1307.001 L0,1307.001 L0,1732.001 Z M640,1635.001 L1920,1635.001 L1920,1410.001 L640,1410.001 L640,1635.001 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconBulletListSquareSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconBulletListSquareSolid, _Component);

  var _super = _createSuper(IconBulletListSquareSolid);

  function IconBulletListSquareSolid() {
    _classCallCheck(this, IconBulletListSquareSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconBulletListSquareSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconBulletListSquare",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconBulletListSquareSolid.displayName = "IconBulletListSquareSolid";
  return IconBulletListSquareSolid;
}(Component);

IconBulletListSquareSolid.glyphName = 'bullet-list-square';
IconBulletListSquareSolid.variant = 'Solid';
IconBulletListSquareSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconBulletListSquareSolid;
export { IconBulletListSquareSolid };